// extracted by mini-css-extract-plugin
export default {"scrolled":"Chart_scrolled__juA7e","reverse_scroll":"Chart_reverse_scroll__BUC7s","bottom_shadow":"Chart_bottom_shadow__q07Up","chart_parent":"Chart_chart_parent__b4Nxp"};